module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.problema.descricao),
      expression: "problema.descricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.problema.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.problema, "descricao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.problema.solucao), function(linha, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Solução " + _vm._s(index + 1))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.descricao),
        expression: "linha.descricao"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (linha.descricao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "descricao", $event.target.value)
        }
      }
    })]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": _vm.adicionarSolucao
      }
    }, [_vm._v("Adicionar Solução")])]) : _c('div', {
      staticClass: "col-md-3 adicionaPreco"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerSolucao(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/problemas"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.submit
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2febc550"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Problemas/novoProblema.vue
// module id = 1221
// module chunks = 1